module.exports = __webpack_public_path__ + "static/media/ic_menu_on_boarding.922312ac.png";